import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// --- Blindagem contra crashes causados por extensões de tradução (Google Tradutor) ---
// O tradutor manipula nós de texto do DOM; ao re-renderizar, o React pode falhar em
// removeChild/insertBefore. Estes wrappers tornam essas operações resilientes.
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

// Silencia o aviso benigno "ResizeObserver loop..." que, em ambiente de
// desenvolvimento, dispara o overlay do CRA e cobre a tela sem ser um erro real.
const _swallowResizeObserver = (e) => {
  const msg = e?.message || "";
  if (msg.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
};
window.addEventListener("error", _swallowResizeObserver);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
